export function getNumberValue(row: Record<string, unknown>, keys: string[]) {
  for (const key of keys) {
    const value = row[key];
    if (typeof value === "number" && Number.isFinite(value)) return value;
    if (typeof value === "string" && value.trim() && Number.isFinite(Number(value))) return Number(value);
  }
  return null;
}

export function getStringValue(row: Record<string, unknown>, keys: string[]) {
  for (const key of keys) {
    const value = row[key];
    if (typeof value === "string" && value.trim()) return value;
  }
  return undefined;
}

export function normalizeFilterValues(values: Record<string, any>) {
  const next = { ...values };
  if (values.dateRange?.length === 2) {
    next.fromDate = values.dateRange[0]?.format?.("YYYY-MM-DD");
    next.toDate = values.dateRange[1]?.format?.("YYYY-MM-DD");
  }
  delete next.dateRange;
  Object.keys(next).forEach((key) => {
    if (next[key] === undefined || next[key] === null || next[key] === "") delete next[key];
  });
  return next;
}

export function getFilterTags(filters: Record<string, unknown>) {
  const labels: Record<string, string> = {
    search: "Search",
    paymentType: "Payment",
    paymentStatus: "Status",
    paidOf: "Paid Of",
    type: "Type",
    bankAccountId: "Bank A/C",
    fromDate: "From",
    toDate: "To"
  };
  return Object.entries(filters)
    .filter(([key, value]) => !["pageNumber", "pageSize"].includes(key) && value !== undefined && value !== null && value !== "")
    .map(([key, value]) => ({ key, label: labels[key] ?? key, value: String(value) }));
}
